import React, { useState, useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import OwnerPageLayout from '../components/layout/OwnerPageLayout';

import { createPlatformApi } from '../utils/platformApi';



export default function BillingSuccessPage() {

    const { t } = useTranslation('platformBilling');

    const api = createPlatformApi();

    const [status, setStatus] = useState(null);

    const [loading, setLoading] = useState(true);



    useEffect(() => {

        loadStatus();

    }, []);



    async function loadStatus() {

        try {

            const res = await api.get('/platform/billing/status');

            setStatus(res.data);

        } catch {

            /* ignore */

        }

        setLoading(false);

    }



    const isActive = status?.platformStatus === 'active';



    return (

        <OwnerPageLayout

            title={isActive ? t('successTitle') : t('processingTitle')}

            subtitle={loading

                ? t('checkingYookassa')

                : isActive

                    ? t('successSubtitle')

                    : t('pendingSubtitle')}

            maxWidth={560}

        >

            <div style={{ padding: '24px 0', textAlign: 'center' }}>

                <div style={{ fontSize: '48px', marginBottom: '16px' }}>{isActive ? '✅' : '⏳'}</div>

                {!loading && status && (

                    <p style={{ fontSize: '13px', color: '#888', marginBottom: '24px' }}>

                        {t('statusLabel')} <strong>{status.platformStatus}</strong>

                        {status.syncedPayments > 0 && t('syncedCount', { count: status.syncedPayments })}

                    </p>

                )}

                <a

                    href={isActive ? '/school' : '/billing'}

                    style={{

                        display: 'inline-block', padding: '14px 28px', background: '#EB3333',

                        color: 'white', borderRadius: '10px', textDecoration: 'none',

                        fontWeight: '700', fontSize: '15px'

                    }}

                >

                    {isActive ? t('toSchool') : t('toBilling')}

                </a>

            </div>

        </OwnerPageLayout>

    );

}


